import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { ReserveState } from "../reserve-state/ReserveStateTypes";

enum SpecialState
{
  cancel_success_sp = "cancel_success_sp",
  refund_success_sp = "refund_success_sp"
}

export type MyState = SpecialState | ReserveState.OrderState

const ProgressSetting: {[key in MyState]: any} = 
{
  "pay_pending":
  {
    "progress": 1,
    "for": "confirming",
    "is-step-pending": "true"
  },

  "pay_fail":
  {
    "progress": 1,
    "for": "confirming",
    "is-step-pending": "true"
  },

  "confirm_pending":
  {
    "progress": 2,
    "for": "confirming",
    "is-step-pending": "true"
  },

  "passenger_filling":
  {
    "progress": 3,
    "for": "confirming",
    "is-step-pending": "true"
  },

  "all_ready":
  {
    "progress": 4,
    "for": "confirming",
    "is-step-pending": "false"
  },

  "started":
  {
    "progress": 4,
    "for": "confirming",
    "is-step-pending": "false"
  },

  "cancel_pending":
  {
    "progress": 2,
    "for": "reserve-cancel",
    "is-step-pending": "false"
  },

  "cancel_fail":
  {
    "progress": 3,
    "for": "reserve-cancel",
    "is-step-pending": "false"
  },

  "cancel_success":
  {
    "progress": 3,
    "for": "reserve-cancel",
    "is-step-pending": "false"
  },

  "cancel_success_sp":
  {
    "progress": 3,
    "for": "cancel-by-system",
    "is-step-pending": "false"
  },

  "refund_success":
  {
    "progress": 4,
    "for": "reserve-cancel",
    "is-step-pending": "false"
  },

  "refund_success_sp":
  {
    "progress": 4,
    "for": "cancel-by-system",
    "is-step-pending": "false"
  },

  "cancel_and_no_refund":
  {
    "progress": 2,
    "for": "confirming",
    "is-step-pending": "false"
  }
}

type IconStyle = "dot" | "check";

export default class FourStepProgress extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
  }

  setState(state: MyState, iconStyle: IconStyle = "check")
  {
    // this.$root.attr("progress", String(data.step));
    // this.$root.attr("for", data.for);
    this.$root.attr("icon-style", iconStyle);
    this.$root.attr("state", state);

    let attrObj = ProgressSetting[state];

    for(let key in attrObj)
    {
      this.$root.attr(key, attrObj[key]);
      // console.log(attrObj[key]);      
    }
  }
}